var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-view"},[_c('controls-panel'),_c('storage-tabs'),(!_vm.isMobile)?[_c('deliveries-table')]:_vm._e(),(_vm.isMobile)?[_c('deliveries-table-mobile')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }